import { useEffect, useState } from 'react';
import { Box, Chip, CircularProgress, Sheet, Stack, Typography } from '@mui/joy';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

import { useAdvertiser } from '../../AdvertiserContext';
import { APIAdsCampaignModerationLog } from '../../api_ads';
import { CAMPAIGN_STATUS_LABELS, MODERATION_STATUS_LABELS } from './adsConstants';


const label = (status) =>
    CAMPAIGN_STATUS_LABELS[status] || MODERATION_STATUS_LABELS[status] || status || '—';


export default function AdModerationLog({ campaignId }) {
    const { advertiserToken: token } = useAdvertiser();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!token || !campaignId) return;
        (async () => {
            try {
                setLoading(true);
                const res = await APIAdsCampaignModerationLog(token, campaignId);
                setItems(res?.items || []);
            } catch (e) {
                setItems([]);
            } finally {
                setLoading(false);
            }
        })();
    }, [token, campaignId]);

    if (loading) {
        return (
            <Stack alignItems="center" sx={{ py: 3 }}>
                <CircularProgress size="sm" />
            </Stack>
        );
    }

    if (!items.length) {
        return (
            <Typography level="body-sm" color="neutral" sx={{ py: 2 }}>
                История модерации пуста — кампания ещё не отправлялась на проверку.
            </Typography>
        );
    }

    return (
        <Stack spacing={1}>
            {items.map((item) => (
                <Sheet key={item.id} variant="soft" sx={{ p: 1.5, borderRadius: 'md' }}>
                    <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={1}
                        justifyContent="space-between"
                        alignItems={{ xs: 'flex-start', sm: 'center' }}
                    >
                        <Stack direction="row" spacing={0.8} alignItems="center" flexWrap="wrap">
                            <Chip size="sm" variant="outlined" color="neutral">
                                {label(item.status_from)}
                            </Chip>
                            <Typography level="body-xs" color="neutral">→</Typography>
                            <Chip
                                size="sm"
                                variant="soft"
                                color={item.status_to === 'rejected' ? 'danger' : 'success'}
                            >
                                {label(item.status_to)}
                            </Chip>
                            {item.creative && (
                                <Chip size="sm" variant="outlined">
                                    Объявление #{item.creative}
                                </Chip>
                            )}
                        </Stack>
                        <Typography level="body-xs" color="neutral">
                            {item.date_create
                                ? format(new Date(item.date_create), 'd MMM yyyy, HH:mm', { locale: ru })
                                : ''}
                            {item.admin_name ? ` · ${item.admin_name}` : ''}
                        </Typography>
                    </Stack>

                    {(item.reason_display || item.comment) && (
                        <Box sx={{ mt: 0.8 }}>
                            {item.reason_display && (
                                <Typography level="body-sm" sx={{ fontWeight: 600 }}>
                                    {item.reason_display}
                                </Typography>
                            )}
                            {item.comment && (
                                <Typography level="body-sm" color="neutral">
                                    {item.comment}
                                </Typography>
                            )}
                        </Box>
                    )}
                </Sheet>
            ))}
        </Stack>
    );
}